/* import __COLOCATED_TEMPLATE__ from './value.hbs'; */
/**

 ## Attribute Value

 The `sq-card/attributes-list/attribute/value` block component is designed to be used as a contextual component in: [sq-card/attributes-list/attribute](/components/glass/sq-card/attributes-list/attribute.html).

 **/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'dd',
  classNames: ['card__attributes-list__attribute__value'],
  attributeBindings: ['data-test-card-attribute-value'],
  'data-test-card-attribute-value': true
});